<template>
  <div class="col-lg-12">
    <div class="card">
      <div class="card-body">
        <h4 class="card-title">{{ holidayRequest.person_full_name }}</h4>

        <p class="card-title-desc">
          Προβολή και Επεξεργασία Αίτησης
        </p>
        <form class="needs-validation" @submit.prevent="SubmitForm">
          <div class="row">
            <div class="col-md-6">
              <div class="mb-3">
                <label for="validationCustom01">Από</label>
                <input id="validationCustom01" type="date" class="form-control" :value="holidayRequest.start_date"
                  disabled />
              </div>
            </div>
            <div class="col-md-6">
              <div class="mb-3">
                <label for="validationCustom01">Εώς</label>
                <input id="validationCustom01" type="date" class="form-control" :value="holidayRequest.end_date"
                  disabled />

              </div>
            </div>
            <span>Ημέρες : <b>{{ holidayRequest.total_holiday_days }}</b></span>
          </div>
          <div class="row mt-3">
            <div class="col-md-12">
              <div class="mb-3">
                <label for="validationCustom01">Αιτία</label>
                <textarea id="validationCustom01" type="text" class="form-control" :value="holidayRequest.reason"
                  disabled />
              </div>
            </div>

          </div>
          <div class="row">
            <div class="col-md-12">
              <div class="mb-3">
                <label for="validationCustom01">Τύπος Άδειας</label>
                <input v id="validationCustom01" type="text" class="form-control"
                  :value="holidayRequest.oracle_leave_type != null ? holidayRequest.oracle_leave_type.leave_type : holidayRequest.holiday_type_title"
                  disabled />

              </div>
            </div>

          </div>

          <div class="row">
            <div class="col-md-12">
              <label for="validationCustom01">Κατάσταση</label>
              <multiselect v-model="holidayStatusSelected" :options="holidayStatuses" track-by="transName"
                label="transName" placeholder="Επιλέξτε Κατάσταση" selectLabel="Eπιλογή Κατάστασης"
                selectedLabel="Επιλέχθηκε" deselectLabel="Αποεπιλογή"></multiselect>
            </div>
          </div>

          <button class="btn btn-primary mt-4" type="submit">
            Ολοκλήρωση
          </button>
        </form>
      </div>
    </div>
    <!-- end card -->
  </div>
</template>


<script>
import Multiselect from "vue-multiselect";
import Swal from "sweetalert2";
import session from "../../../../api/session";
export default {
  components: { Multiselect },
  props: ["holidayRequest"],
  data() {
    return {
      holidayStatuses: [
        { id: 1, name: "pending", transName: "Εκκρεμής" },
        { id: 2, name: "approved", transName: "Έγκριση" },
        { id: 3, name: "declined", transName: "Απόρριψη" },
      ],
      holidayStatusSelected: null,
    };
  },
  mounted() {
    this.holidayStatusSelected = this.holidayStatuses.find(
      status => status.name === (this.holidayRequest && this.holidayRequest.status)
    );
  },

  methods: {
    SubmitForm() {
      Swal.fire({
        title: "Είστε σίγουροι?",
        text: "Η κατάσταση θα αλλάξει!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Ναι",
        cancelButtonText: "Ακυρο",
      }).then((result) => {
        if (result.value) {
          this.updateStatus(this.holidayRequest.id, this.holidayStatusSelected);
          //   Swal.fire("Deleted!", "Your file has been deleted.", "success");
        }
      });
    },

    updateStatus(id, status) {
      const data = {
        status: status.name,
      };
      session
        .put(`api/holiday-request-status/${id}/update/`, data)
        .then(() => {
          Swal.fire("Επιτυχία!", "Η κατάσταση ανανεώθηκε.", "success");
          this.$emit("updatedStatus", id);
        })
        .catch((e) => {
          console.log(e);
          Swal.fire({
            title: "Ουπς! Κάτι πήγε στραβά",
            text: "Παρακαλώ επικοινωνήστε με τους διαχειριστές",
            icon: "error",
          });
        });
    },
  },
};
</script>